import React from 'react';
import RemoteImageReferralSearchBox from '../RemoteImageReferralSearchBox';
import RemoteImageReferralList from '../RemoteImageReferralList';
import { _LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';

const RemoteImageReferralListWrap = (props) => {
  const { remoteImageReferralList, setData, getList } = props;

  return (
    <div className="remote-image-list-wrap">
      {/* 원격 이미지 검색 박스 */}
      <RemoteImageReferralSearchBox
        searchData={remoteImageReferralList.searchData}
        setData={(data) =>
          setData({
            path: ['remoteImageReferralList', 'searchData', ...data.path],
            value: data.value,
          })
        }
        getList={getList}
      />

      {/* 원격 이미지 리스트 */}
      <RemoteImageReferralList
        remoteImageList={remoteImageReferralList.list}
        initialOption={{
          pagination: _LIST_PAGINATION_MODEL,
        }}
        pagination={remoteImageReferralList.pagination}
        getList={getList}
      />
    </div>
  );
};

export default RemoteImageReferralListWrap;
